import { CONTACT_EMAIL } from '../lib/site';

/**
 * Published team copy. About reads this list.
 * Do not add a person here unless their name, role, and bio already exist.
 */
export interface StaffMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  priorExperience: string;
  education: string;
  biggestGoal: string;
  image?: string;
  linkedin?: string;
  email?: string;
}

export const STAFF: StaffMember[] = [
  {
    id: 'andrew-fairbank',
    name: 'Andrew Fairbank',
    role: 'Co-Founder + Chief Product Officer',
    bio: 'Currently enrolled at Iona University, Andrew is a student athlete for Rowing, and is striving to make software that can help people in the future.',
    priorExperience: '3+ years of hands on coding and development through highschool classes and personal projects. Currently focused on developing apps for the company.',
    education: 'Currently pursuing a Masters degree in Computer Science at Iona University through their accelerated masters program.',
    biggestGoal: 'To create apps that are focused on being self sustaining and bringing as much benefit as possible to the users while creating minimal profits.',
  },
  {
    id: 'brennan-faires',
    name: 'Brennan Faires',
    role: 'Co-Founder + Chief Technology Officer',
    bio: 'Currently a student at the University of Colorado Boulder, Brennan is an aspiring network engineer with his sights set on future advancements in network infrastructure.',
    priorExperience: '4+ years of hands-on development experience through internships and personal projects. Focused on network and database management, and full stack development. Currently working as a systems administrator for the University of Colorado Boulder.',
    education: 'Currently pursuing a Bachelor\'s in Computer Science Engineering at University of Colorado Boulder, and an accelerated masters in Network Engineering. Secondary bachelor\'s in Philosophy with a minor in Sociology.',
    biggestGoal: 'To create a network infrastructure that is self sustaining and brings as much benefit as possible to the users while creating minimal profits. Bringing cost efficient solutions to small businesses and organizations.',
    image: '/BrennanPFP.jpg',
    linkedin: 'https://www.linkedin.com/in/brennan-faires-a41438312/',
    email: CONTACT_EMAIL,
  },
];
